import HTMLTemplate from './template.html'
import './../EventPanel/styles.scss' // Might need to look at improving this later - DRS
import './../EventDetailsPanel/styles.scss' // Might need to look at improving this later - DRS
import './styles.scss'
import moment from 'moment'
import 'moment-timezone'

export const AviationAlertEventDetailsPanel = (() => {
    const guessedTimeZone = moment.tz(moment.tz.guess()).format('z')
    const vueComponent = {
        data() {
            return {
                isPanelOpen: false,
                avsecAlerts: []
            }
        },
        methods: {
            showAvsecAlerts(avsecAlerts) {
                this.avsecAlerts = avsecAlerts
                this.showPanel()
            },
            showPanel() {
                this.isPanelOpen = true
                document.getElementsByClassName('app-template')[0].classList.add('aviation-alert-event-detail-panel-show')

                // Reset scroll position
                this.$refs.aviationAlertContent.scrollTop = 0
            },
            hidePanel() {
                this.isPanelOpen = false
                document.getElementsByClassName('app-template')[0].classList.remove('aviation-alert-event-detail-panel-show')
            },
            getEventFormattedDate(date) {
                return moment(date).format('DD MMM YYYY HH:mm') + ' ' + guessedTimeZone
            },
            getEventSimplifiedDate(date) {
                if (date === '' || date === undefined) return '' 
                return moment(date).format('YYYY-MM-DD HH:mm') + ' ' + guessedTimeZone
            },
            getEventJustDate(date) {
                if (date === '' || date === undefined) return '' 
                return moment(date).format('DD MMM YYYY') + ' ' + guessedTimeZone
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-aviation-alert-event-details-panel')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
